import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { hasReactChildren } from 'utils/ui';
import getAccumulatedCompletionTime from 'utils/asset/getAccumulatedCompletionTime';
import Button from 'components/Button';
import ContentProgressCircle from 'components/ContentProgressCircle';
import Flag from 'components/Flag';
import Flex from 'components/Flex';
import Stack from 'components/Stack';
import { useDisclosure } from 'components/Disclosure';
import Icon from 'components/Icon';
import { getAllContentChildren } from 'screens/PlaylistManageContentScreen/Editor/utils/getAllContentChildren';
import SectionBlock from './SectionBlock';
import SectionContentInfo from './SectionContentInfo';
import VisuallyHidden from 'components/VisuallyHidden';
import { getSectionProgress } from './utils/getSectionProgress';
import { checkIsSectionLockedForPreview } from './utils/checkIsSectionLockedForPreview';
import { useLockingInfoText } from './utils/useLockingInfoText';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Section(_ref) {
  var isSectionOpen = _ref.isSectionOpen,
    hasPlaylistNumbering = _ref.hasPlaylistNumbering,
    _ref$isPreviewMode = _ref.isPreviewMode,
    isPreviewMode = _ref$isPreviewMode === void 0 ? false : _ref$isPreviewMode,
    section = _ref.section,
    children = _ref.children,
    onToggleOpen = _ref.onToggleOpen;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useDisclosure = useDisclosure({
      controlledState: isSectionOpen,
      setControlledState: onToggleOpen
    }),
    isVisible = _useDisclosure.isVisible,
    buttonProps = _useDisclosure.buttonProps,
    contentProps = _useDisclosure.contentProps;
  var sectionIsLockedForPreview = checkIsSectionLockedForPreview(isPreviewMode, section);
  var showAsLocked = isPreviewMode ? sectionIsLockedForPreview : !!section.isLockedForUser;
  var lockingInfoText = useLockingInfoText({
    section: section
  });
  var sectionContent = getAllContentChildren(section.children);
  var sectionProgress = getSectionProgress(sectionContent);
  var contentItemCount = (isPreviewMode ? sectionContent.length : section.contentCount) || 0;
  var hideItemCount = showAsLocked && contentItemCount === 0;
  var hasSectionContent = contentItemCount > 0;
  var sectionDuration = (isPreviewMode ? getAccumulatedCompletionTime(sectionContent) : section.completionTime) || 0;
  return /*#__PURE__*/_jsx(Flag, {
    align: "top",
    spacing: "s",
    token: /*#__PURE__*/_jsx(ContentProgressCircle, {
      contentName: section.name,
      infoReadout: "tooltip",
      progress: sectionProgress,
      isContentLocked: showAsLocked
    }),
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "s",
      children: [/*#__PURE__*/_jsx(SectionBlock, {
        section: section,
        hasPlaylistNumbering: hasPlaylistNumbering
      }), (hasSectionContent || showAsLocked) && /*#__PURE__*/_jsxs(Flex, {
        wrap: true,
        gap: "s",
        children: [!showAsLocked && /*#__PURE__*/_jsxs(Button, _objectSpread(_objectSpread({
          size: "small",
          variant: "shaded",
          iconOnly: isVisible,
          iconRight: /*#__PURE__*/_jsx(Icon, {
            name: "chevron",
            flip: isVisible ? 'y' : undefined,
            rotate: isVisible ? undefined : -90
          })
        }, buttonProps), {}, {
          children: [t('actions_open'), /*#__PURE__*/_jsxs(VisuallyHidden, {
            children: [" ", section.name]
          })]
        })), /*#__PURE__*/_jsx(SectionContentInfo, {
          lockingInfoText: showAsLocked ? lockingInfoText : undefined,
          contentItemCount: hideItemCount ? undefined : contentItemCount,
          sectionDuration: sectionDuration
        })]
      }), hasReactChildren(children) && /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, contentProps), {}, {
        children: children
      }))]
    })
  });
}
export default Section;